import React, { useEffect, useState } from "react";
import ProgressBar from "react-customizable-progressbar";
import BaseImage from "../../assets/images/dasboard/base.webp";
import NoFoodImage from "../../assets/images/dasboard/no-food.png";
import BasketImage from "../../assets/images/dasboard/basket.png";
import WeightImage from "../../assets/images/dasboard/weight.png";
import FireImage from "../../assets/images/dasboard/fire.webp";
import FireActiveImage from "../../assets/images/dasboard/fireac.webp";
import SelfieImage from "../../assets/images/selfie.png";
import { Link } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import axios from "axios";
import { FASTING_TRACK_ENDPOINT } from "../../config/ApisCollection";
import StreakSection from "./StreakSection";

const StartingFasting = ({
  dashboardData,
  setIsFastingTrue,
  currentDayName,
  postFastingApi,
}) => {
  const [progress] = useState(0);
  const accessToken = secureLocalStorage.getItem("accessToken");
  const windowType = dashboardData?.fastingtrack?.type;

  return (
    <>
      <div className="clik-selfie-inline">
        <div>
          <div className="circleplayer">
            <div
              className="circleplayer1 cursor-not-allowed"
              onClick={() => {
                if (setIsFastingTrue) {
                  setIsFastingTrue(true);
                  postFastingApi();
                }
              }}
            >
              <ProgressBar
                strokeWidth={28}
                strokeColor="#FF9950"
                strokeLinecap="round"
                trackStrokeWidth={8}
                className="circleplayer2 z-20"
                radius={100}
                progress={progress}
                cut={180}
                rotate={-180}
              ></ProgressBar>
              <div className="circleplayer3 cursor-not-allowed z-10">
                <div>
                  <div className="palyerdes">
                    <i
                      className="fa fa-play"
                      aria-hidden="true"
                      style={{ color: "#fff" }}
                    ></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="desbase mb-5">
            <img
              loading="lazy"
              src={BaseImage}
              alt="no-food"
              className="deshimg opacity-25"
            />
          </div>
          <p className="destile text-sm font-medium text-black !mb-5">
            Today is your treat day
          </p>
          <StreakSection
            fastingStreek={null}
            time={"time"}
            dashboardData={dashboardData}
          />
        </div>
        {/* <div className='selfie-person'>
              <img src={SelfieImage} height={496} width={259} alt='Selfie' />
            </div> */}
      </div>
    </>
  );
};

export default StartingFasting;
